import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import {APP_NAME} from "../App";


export default function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" mt={1} mx={-15} sx={{userSelect: "none"}}>
            {"Copyright © "}
            <Link href="/">{APP_NAME}&nbsp;</Link>
            {new Date().getFullYear()}
        </Typography>
    );
}
